import React, { useCallback, useState } from 'react';

import {
  advanceLogoStep,
  initialLogoStep,
  logoSrcForStep,
  type CompanyLogoStep,
} from '../utils/companyLogo';

export interface CompanyLogoProps {
  url?: string | null;
  company: string;
  imgClassName?: string;
  imgStyle?: React.CSSProperties;
  fallbackClassName?: string;
  fallbackStyle?: React.CSSProperties;
  alt?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({
  url,
  company,
  imgClassName,
  imgStyle,
  fallbackClassName,
  fallbackStyle,
  alt,
}) => {
  const [step, setStep] = useState<CompanyLogoStep>(() => initialLogoStep(url));
  const initial = (company.trim()[0] ?? '?').toUpperCase();
  const src = logoSrcForStep(step, url, company);

  const advance = useCallback(() => {
    setStep((s) => advanceLogoStep(s));
  }, []);

  if (!src || step === 'fallback') {
    return (
      <div
        className={fallbackClassName}
        style={fallbackStyle}
        aria-hidden={alt === undefined}
      >
        {initial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt ?? `${company} logo`}
      className={imgClassName}
      style={imgStyle}
      loading="lazy"
      decoding="async"
      onError={advance}
    />
  );
};

export default CompanyLogo;
